import { render, staticRenderFns } from "./BaseViewSwitcher.vue?vue&type=template&id=7eec5dfb"
import script from "./BaseViewSwitcher.vue?vue&type=script&lang=js"
export * from "./BaseViewSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BaseViewSwitcher.vue?vue&type=style&index=0&id=7eec5dfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports